export interface CardButtonActionResponse {
  actionKey: string;
  actionType?: string;
  actionData?: any;
}
